import { render, staticRenderFns } from "./text-cta-image.vue?vue&type=template&id=5eb65d40"
import script from "./text-cta-image.vue?vue&type=script&lang=js"
export * from "./text-cta-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports